var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Watch } from 'vue-property-decorator';
import { connect } from '@/overmind';
import { formatCnpj, getWidthByScreen, hasAtlasV4, } from '@/shared/utils/helpers';
import { isEmpty } from 'lodash';
import CompanyDetailIframeModal from '@/components/CompanyDetailIframeModal.vue';
import CompanyDetails from '@/modules/infosets/components/CompanyDetails.vue';
let CompanyDetailsContainer = class CompanyDetailsContainer extends Vue {
    constructor() {
        super(...arguments);
        this.showCompanyDetail = false;
        /**
         * Rastreia o companyId cujo getData() já foi (ou está sendo) executado nesta
         * instância. Evita que mounted() e @Watch('$route') disparem getData() duas
         * vezes para o mesmo companyId quando o guard atualiza state.currentCompanyId
         * antes do router confirmar a navegação.
         */
        this._fetchingCompanyId = null;
    }
    /**
     * ATENCAO: metodo, nao `get`. Um `get` de classe vira computed do Vue, e
     * computed so reavalia quando uma dependencia REATIVA muda. O connect do
     * overmind grava `currentUser`/`companiesState` com Object.assign (props
     * comuns, nao reativas) e propaga mudanca chamando $forceUpdate(), que
     * re-renderiza mas NAO invalida cache de computed. Como metodo, o render
     * reavalia sempre. Ver currentCnpj() para o caso que quebrou em producao.
     */
    hasV4() {
        const stateUser = this.currentUser;
        // Sem optional chaining: o ts-loader/webpack desta config nao parseia `?.`
        const auth = Vue.auth;
        const authUser = auth && typeof auth.user === 'function' ? auth.user() : null;
        const user = stateUser && Object.keys(stateUser).length > 0 ? stateUser : authUser;
        return hasAtlasV4(user);
    }
    /** ID do infoset atual como string (para repassar ao iframe). Metodo, nao
     * `get`, pelo mesmo motivo descrito em hasV4(). */
    currentInfosetIdStr() {
        // @ts-ignore TS2349: property inexistent
        const state = this.companiesState;
        // Evita ?. e ?? — não suportados pelo ts-loader do Vue 2 nesta config
        const id = (state && state.currentInfosetId) ||
            (this.$route && this.$route.params && this.$route.params.infosetId) ||
            null;
        return id ? String(id) : null;
    }
    /**
     * CNPJ da empresa atual — disponivel apenas apos o carregamento assincrono.
     *
     * Precisa ser METODO. Como `get` (computed), era avaliado no primeiro render
     * do container, quando currentCompany ainda e undefined, e o `null` ficava
     * em cache para sempre: o fetch chegava, o overmind chamava $forceUpdate(),
     * o render rodava de novo e lia o mesmo `null` cacheado. Resultado em
     * producao: showCompanyDetail=true, hasV4=true, GET da empresa em 200 com o
     * CNPJ no estado — e o v-if abaixo nunca liberava o painel. Nenhum dos dois
     * ramos renderizava e o usuario clicava no card sem nada acontecer.
     */
    currentCnpj() {
        // @ts-ignore TS2349: property inexistent
        const state = this.companiesState;
        const company = state && state.currentCompany ? state.currentCompany : null;
        return company && company.cnpj ? company.cnpj : null;
    }
    beforeCloseCompanyDetail() {
        const { infosetId: id } = this.$route.params;
        const { view_as: viewAs } = this.$route.query;
        this.showCompanyDetail = false;
        // @ts-ignore TS2349: property inexistent
        this.companiesActions.resetCurrentCompany();
        if (id) {
            if (viewAs) {
                this.$router.replace({
                    path: `/infosets/${id}`,
                    query: { view_as: viewAs },
                });
            }
            else
                this.$router.replace({ path: `/infosets/${id}` });
        }
        else {
            this.$router.replace({
                // @ts-ignore TS2349: property inexistent
                path: `/infosets/${this.companiesState.currentInfosetId}`,
            });
        }
    }
    async onRoute(to, from) {
        if (to.params.companyId && to.params.infosetId) {
            // Evita duplo getData() quando mounted() já iniciou a busca para o mesmo
            // companyId (acontece porque o guard atualiza state.currentCompanyId antes
            // do router confirmar a navegação, causando o mount antes de $route mudar).
            if (this._fetchingCompanyId === to.params.companyId)
                return;
            this.showCompanyDetail = true;
            // @ts-ignore TS2349: property inexistent
            this.companiesActions.setCurrentCompanyByID(to.params.companyId);
            // @ts-ignore TS2349: property inexistent
            this.companiesActions.setCurrentInfosetByID(to.params.infosetId);
            // Busca a empresa pelo ID para popular currentCompany.cnpj,
            // necessário para que v-if="currentCnpj" permita o modal renderizar.
            await this.getData(to.params.infosetId, to.params.companyId);
        }
    }
    async onShowCompanyDetailChanged(val, oldVal) {
        const { infosetId: id, companyId } = this.$route.params;
        if (val) {
            // @ts-ignore TS2349: property inexistent
            this.companiesActions.setCurrentCompanyByID(companyId);
            // @ts-ignore TS2349: property inexistent
            this.companiesActions.setCurrentInfosetByID(id);
        }
    }
    loadedCurrentCompany() {
        // @ts-ignore TS2349: property inexistent
        return !isEmpty(this.currentCompany);
    }
    /** Aba "Dados adicionais" do drawer antigo: carrega a árvore hiperbólica. */
    getAdditionalData(tab) {
        // @ts-ignore TS2349: property inexistent
        this.companiesActions.setHyperbolicData({ nodes: [], links: [] });
        if (tab === 'additional-data') {
            // @ts-ignore TS2349: property inexistent
            if (this.companiesState.currentCompany) {
                if (
                // @ts-ignore TS2349: property inexistent
                this.companiesState.currentCompany.badges &&
                    // @ts-ignore TS2349: property inexistent
                    this.companiesState.currentCompany.badges
                        .hyperbolictree_size_estimation > 1) {
                    // @ts-ignore TS2349: property inexistent
                    this.companiesActions.getCompanyHyperbolicData(
                    // @ts-ignore TS2349: property inexistent
                    { cnpj: this.companiesState.currentCompany.cnpj });
                }
            }
        }
    }
    async getData(infosetId, companyId) {
        this._fetchingCompanyId = companyId;
        // @ts-ignore TS2349: property inexistent
        await this.companiesActions.getCompanyByID({
            infosetId: infosetId,
            companyId: companyId,
        });
    }
    async getCompanyCnpjsNextPage(page) {
        // @ts-ignore
        await this.companiesActions.getCompanyCnpjs({
            // @ts-ignore
            cnpj: formatCnpj(this.currentCompany.cnpj),
            page,
        });
    }
    getWidth() {
        return getWidthByScreen();
    }
    async mounted() {
        const { infosetId: id, companyId } = this.$route.params;
        if (id && companyId) {
            this.showCompanyDetail = true;
            // Define o infoset antes de buscar os dados da empresa para garantir que
            // currentInfosetIdStr retorne o valor correto no momento em que o iframe
            // do CompanyDetailIframeModal montar (disparado pelo currentCnpj truthy).
            // @ts-ignore TS2349: property inexistent
            this.companiesActions.setCurrentInfosetByID(id);
            await this.getData(id, companyId);
            // @ts-ignore TS2349: property inexistent
            this.companiesActions.setCurrentCompanyByID(companyId);
        }
        this.$emit('mixtracking', 'pre-crm: Acessou informações da companhia');
    }
    beforeDestroy() {
        // NAO limpar currentCompany*/currentInfosetId aqui. Este container e
        // recriado a cada troca de :key="currentCompanyId": ao abrir a empresa B
        // com a A ainda em estado, o Vue monta a instancia de B e so entao
        // destroi a de A — o reset da instancia antiga zerava currentCompanyId e
        // desmontava a instancia nova, deixando a URL apontando para uma empresa
        // sem nenhum detalhe aberto (e, a partir dai, nenhum card abria mais).
        // O reset acontece em beforeCloseCompanyDetail() e em cleanStore(), ao
        // sair do infoset.
    }
};
__decorate([
    Watch('$route')
], CompanyDetailsContainer.prototype, "onRoute", null);
__decorate([
    Watch('showCompanyDetail')
], CompanyDetailsContainer.prototype, "onShowCompanyDetailChanged", null);
CompanyDetailsContainer = __decorate([
    Component(connect(({ state, actions }) => ({
        companiesState: state.companies,
        currentCompany: state.companies.currentCompany,
        currentCompanyId: state.companies.currentCompanyId,
        currentInfosetId: state.companies.currentInfosetId,
        companiesActions: actions.companies,
        companyStatus: state.companies.companyStatus,
        hyperbolicData: state.companies.hyperbolicData,
        currentUser: state.users.currentUser,
    }), { components: { CompanyDetailIframeModal, CompanyDetails } }))
], CompanyDetailsContainer);
export default CompanyDetailsContainer;
